export const DATASETS = {
  CSRD: "csrd",
  NIFTY: "nifty",
  ALL: "all",
}

export const TABLE_FRAMEWORKS = ["GRI", "BRSR", "SBTi", "TCFD"]

export const COLORS = {
  primaryTeal: "#407775",
  lightTeal: "#6F9896",
  gold: "#FAB430",
  darkText: "#494949",
  grayText: "#707070",
  background: "#F5F5F5",
  cardBorder: "#E5E5E5",
  altRow1: "#FCF7EE",
  altRow2: "#DAECEC",
}
